import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { IntegrationPartners } from '../../helpers/constants';
import { CaretDown } from '../icons';

const IntegrationPartnerPicker = ({
  label = 'Year',
  onChange = () => {},
  placeholder = 'Select',
  value = 0,
  errorMessage = '',
  required = false,
  className = '',
}) => {
  const makeDropdown = () => {
    return Object.entries(IntegrationPartners).map(o => {
      return { key: o[0], text: o[1] };
    })
      .sort((a, b) => a.text.localeCompare(b.text));
  };

  return (
    <Dropdown
      onRenderCaretDown={() => <CaretDown />}
      label={label}
      onChange={onChange}
      placeholder={placeholder}
      selectedKey={value}
      options={[{ key: 0, text: 'Select' }, ...makeDropdown()]}
      errorMessage={errorMessage}
      required={required}
      className={className}
    />
  );
};

IntegrationPartnerPicker.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default IntegrationPartnerPicker;
